<template>
  <div class="actorList" @click="clickAll">
    <div v-if="screenShow" class="screen-wrapper" id="myScreen" style="width: 100%;">
      <div class="screen-content">
        <div class="search-tag">

          <div class="tag-con3">

            <div class="float-left tag-left">性别</div>
            <div class='float-left tag-right'>
              <el-radio-group v-model="sex" size="small" border=false>
                <el-radio-button label="">不限</el-radio-button>
                <el-radio-button label="1">男</el-radio-button>
                <el-radio-button label="2">女</el-radio-button>

              </el-radio-group>

            </div>
            <div class="clearfix"></div>
          </div>

          <div class="tag-con3">
            <div class="float-left tag-left">身高</div>
            <div class='float-left tag-right'>
              <el-radio-group v-model="stature" size="small" border=false>
                <el-radio-button label="">不限</el-radio-button>
                <el-radio-button label="0,150">150cm以下</el-radio-button>
                <el-radio-button label="150,160">150cm-160cm</el-radio-button>
                <el-radio-button label="160,170">160cm-170cm</el-radio-button>
                <el-radio-button label="170,180">170cm-180cm</el-radio-button>
                <el-radio-button label="180,190">180cm-190cm</el-radio-button>
                <el-radio-button label="190,250">190cm以上</el-radio-button>
              </el-radio-group>

            </div>
            <div class="clearfix"></div>
          </div>
          <div class="tag-con3">
            <div class="float-left tag-left">脸型</div>
            <div class='float-left tag-right'>
              <el-radio-group v-model="feature" size="small" border=false>
                <el-radio-button label="">不限</el-radio-button>
                <el-radio-button label="1">菱形脸</el-radio-button>
                <el-radio-button label="2">鹅蛋脸</el-radio-button>
                <el-radio-button label="3">国字脸</el-radio-button>
                <el-radio-button label="4">瓜子脸</el-radio-button>
                <el-radio-button label="5">圆形脸</el-radio-button>
                <el-radio-button label="6">方形脸</el-radio-button>
                <el-radio-button label="7">三角脸</el-radio-button>
              </el-radio-group>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="tag-con3">
            <div class="float-left tag-left">职业</div>
            <div class='float-left tag-right'>
              <el-radio-group v-model="vocation" size="small" border=false>

                <el-radio-button label="">不限</el-radio-button>
                <el-radio-button label="1">演员</el-radio-button>
                <el-radio-button label="2">模特</el-radio-button>
                <el-radio-button label="3">歌手</el-radio-button>
                <el-radio-button label="4">导演</el-radio-button>
                <el-radio-button label="5">副导演</el-radio-button>
                <el-radio-button label="6">编剧</el-radio-button>
                <el-radio-button label="7">制片</el-radio-button>
                <el-radio-button label="8">主持人</el-radio-button>
              </el-radio-group>

            </div>
            <div class="clearfix"></div>
          </div>
          <div class="tag-con3">
            <div class="float-left tag-left">特长</div>
            <div class='float-left tag-right'>
              <el-checkbox-group v-model="tag" border=false>
                <el-checkbox-button v-for="item in tags" :label="item.key" :key="item.key" @change="choose(item.key)">
                  {{item.value}}
                </el-checkbox-button>

              </el-checkbox-group>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="tag-con3">
            <div class="float-left tag-left">标签</div>
            <div class='float-left tag-right'>
              <el-checkbox-group v-model="label" border=false>
                <el-checkbox-button v-for="item in labels" :label="item.key" :key="item.key"
                                    @change="choose2(item.key)">
                  {{item.value}}
                </el-checkbox-button>
              </el-checkbox-group>
            </div>
            <div class="clearfix"></div>
          </div>

          <div style="margin: 0 auto;display: flex;justify-content: space-around;">
            <input type="button" class="bk-search-btn" value="筛选" @click="getsearch"/>
            <input type="button" class="bk-search-btn" value="取消" @click="cancel"/>
          </div>

        </div>
      </div>
    </div>
    <div class="mask" v-if="maskShow" @touchmove.prevent></div>
    <!--轮播图-->
    <div>
      <swiper :options="swiperOption">
        <swiper-slide v-for="item in actorListSlide" :key="item.id">
          <img :src="item.images.image_url" style="width: 100%;height: auto" alt="banner">
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!--热门艺人-->
    <div class="hotActor">
      <div class="hotTitle">
        <span>热门艺人排行</span>
      </div>
      <ul class="hotA-wrapper">
        <li v-for="item in hotActorList" :key="item.key" class="hotActor-img-wrapper">
          <router-link :to="{
            name:'Actor',
             params:{
               id:item.id
              }
          }">
            <div class="hot-img-wrapper">
              <img :src='item.picture' :alt="item.name" class="hotA-img"/>
            </div>
            <div class="hot-ab">
              <div class="aName">
                <span>{{item.name}}</span>
              </div>
              <div style="display: flex; ">
                <svg class="icon hotIcon" aria-hidden="true">
                  <use xlink:href="#icon-redu"></use>
                </svg>
                <div class="hot-num">
                  <span>{{item.hot_number}}</span>
                </div>

              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
    <!--查找艺人-->
    <div class="searchActor">
      <div @click="Screening" class="searchActorBtn">
        <div>
          <p>点击输入筛选条件</p>
        </div>
      </div>
      <div class="shouActorList">
        <ul>
          <li v-for="item in showList" :key="item.id" class="actList-wrapper">
            <router-link :to="{
              name:'Actor',
              params:{
               id:item.id
              }
            }">
              <div style="display: flex;">
                <div>
                  <img :src="item.picture" :alt="item.name" class="actImg">
                </div>
                <div class="actorName">
                  <p
                    style="margin-top: -.1rem; font-size:.33rem;font-weight: 600; font-family: MicrosoftYaHei;color: #333;text-align: left;">
                    {{item.name}}</p>
                  <div class="a-info"><span class="info-title">身高:</span>
                    <p>{{item.stature}}cm</p>
                  </div>
                  <div class="a-info"><span class="info-title">体重:</span>
                    <p>{{item.weight}}kg</p>
                  </div>
                  <div class="a-info"><span class="info-title">签名:</span>
                    <p class="info-c">{{item.signature}}</p>
                  </div>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <v-page :total-row="totalRow" align="center" :page-size-menu="false" :info="false"
              @page-change="pageChange" v-if="this.err !== 20001"></v-page>
      <div v-show="this.err === 20001"
           style="font-size: .4rem;width: 100%;display: flex;justify-content: center;color: red;"><p>没有相关数据</p></div>
    </div>
  </div>
</template>

<script>

  import {swiper, swiperSlide} from 'vue-awesome-swiper'
  import pageNation from './pageNation'
  import '../../theme/index.css'

  export default {
    name: "ActorList",
    data() {
      return {
        detailsList: [],
        total: 0,
        errShow: false,
        err: 0,
        pgShow: true,
        infoP: {},
        totalRow: 100,
        pageNum: 1,
        pageArr: [],
        actorListSlide: [],
        hotActorList: [],
        showList: [],
        swiperOption: {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 30,
          // loop: true,
          autoplay: {
            delay: 5000,
          },
          pagination: {
            el: '.swiper-pagination',
            dynamicBullets: true
          },
          effect: 'fade'
        },
        screenShow: false,
        maskShow: false,
        sex: '',
        stature: '',
        feature: '',
        vocation: '',
        tag: ['0'],
        tags: [{
          'key': '0',
          'value': '不限'
        },
          {
            'key': '1',
            'value': '唱歌'
          },
          {
            'key': '2',
            'value': '跳舞'
          },
          {
            'key': '3',
            'value': '武术'
          },
          {
            'key': '4',
            'value': '骑马'
          },
          {
            'key': '5',
            'value': '乐器'
          },
          {
            'key': '6',
            'value': '方言'
          },
          {
            'key': '7',
            'value': '外语'
          },
          {
            'key': '8',
            'value': '主持'
          },
          {
            'key': '9',
            'value': '驾驶'
          },
          {
            'key': '10',
            'value': '书画'
          }


        ],
        label: ['0'],
        labels: [{
          'key': '0',
          'value': '不限'
        },
          {
            'key': '11',
            'value': '特型'
          },
          {
            'key': '12',
            'value': '朴实'
          },
          {
            'key': '13',
            'value': '谐星'
          },
          {
            'key': '14',
            'value': '胖咖'
          },
          {
            'key': '15',
            'value': '丑咖'
          },
          {
            'key': '16',
            'value': '痞气'
          },
          {
            'key': '17',
            'value': '反派'
          },
          {
            'key': '18',
            'value': '中性'
          },
          {
            'key': '19',
            'value': '妩媚'
          },
          {
            'key': '20',
            'value': '性感'
          },
          {
            'key': '21',
            'value': '知性'
          },
          {
            'key': '22',
            'value': '御姐'
          },
          {
            'key': '23',
            'value': '帅气'
          },
          {
            'key': '24',
            'value': '大叔'
          },
          {
            'key': '25',
            'value': '霸道'
          },
          {
            'key': '26',
            'value': '成熟'
          },
          {
            'key': '27',
            'value': '小鲜肉'
          },
          {
            'key': '28',
            'value': '阳光'
          },
          {
            'key': '29',
            'value': '暖男'
          },
          {
            'key': '30',
            'value': '老戏骨'
          },
          {
            'key': '31',
            'value': '喜剧性'
          },
          {
            'key': '32',
            'value': '硬汉'
          },
          {
            'key': '33',
            'value': '文艺范'
          },
        ],
        seoList: [],
        keyword: [],
        a:''
      }
    },
    components: {
      swiper,
      swiperSlide,
      pageNation
    },
    metaInfo() {
      return {
        title: this.seoList.column_title?`${this.seoList.column_title}-打造影视行业优秀的资源聚合服务平台` : '',
        meta: [{
          name: 'keywords',
          content: this.seoList.column_keywords || ''
        },
          {
            name: 'description',
            content: this.seoList.column_description || ''
          }]
      }
    },
    methods: {
      getSeo(){
        let seoApi = 'https://api.yopoo.cn/api/v1/perfsearch'
        this.$http.get(seoApi)
          .then((res)=>{
            this.seoList = res.data.metas
            this.column_title = this.seoList.column_title
            this.column_keywords = this.seoList.column_keywords
            this.column_description = this.seoList.column_description
          },err =>{
            console.log(err)
          })
      },
      getDetails() {
        let detailsApi = `https://api.yopoo.cn/api/v1/actor?id=${this.$route.params.id}`
        this.$http.get(detailsApi).then(res => {
          this.detailsList = res.data
        }, err => {
          console.log(err)
        })
      },
      cancel() {
        this.screenShow = false
        this.maskShow = false
      },
      choose(e) { //判断点击状态
        if (e == 0) {     //判断e=0的情况来增加选中结果
          this.tag = ['0']
        }
        if (e != 0) {     //判断e！=0的情况
          for (var i = 0; i < this.tag.length; i++) {
            if (this.tag[i] == 0) {   //在this.tag中如果i=0
              this.tag.splice(this.tag[i], 1) //将等于0的值从this.tag数组中删掉
            }
          }
        }

      },
      choose2(e) { //判断点击状态
        if (e == 0 || this.label == '') {  //判断e=0的情况来增加选中结果
          this.label = ['0']
        }
        if (e != 0) {   //判断e！=0的情况
          for (var i = 0; i < this.label.length; i++) {
            if (this.label[i] == 0) {  //在this.label中如果i=0
              this.label.splice(this.label[i], 1)//将等于0的值从this.label数组中删掉
            }
          }
        }


      },
      getsearch() {
        this.screenShow = false
        this.maskShow = false
        // this.tag.concat(this.label)
        if (this.tag == '0' && this.label == '0') { //判断如果tag和label的值都为0，则this.keyword字段为空
          this.keyword = ''
        } else {
          this.keyword = this.tag.concat(this.label)
        }
        var api = 'https://api.yopoo.cn/api/v1/perfsearch?sex=' + this.sex + '&feature=' + this.feature + '&stature=' +
          this.stature + '&keyword=' + this.keyword + '&vocation=' + this.vocation + '&page=' + this.pageNum + '&count=' + this.infoP.pageSize + '&sort=esc' +
          '&order=id'
        this.$http.get(api).then((res) => {
          this.err = res.data.error_code
          this.showList = res.data.data
          this.totalRow = res.data.pagination.total
          this.total = res.data.pagination.total
          if (this.total < 12) {
            this.pgShow = false
          }
          if (this.err === 20001) {
            this.pgShow = false
          }

        }, err => {
          console.log(err)
        })
      },
      getActorSwiper() {
        let aSwiperApi = 'https://api.yopoo.cn/api/v1/homeshow'
        this.$http.get(aSwiperApi, {
          params: {
            property: 3,
            count: 3
          }
        }).then(res => {
          this.actorListSlide = res.data
        }, err => {
          console.log(err)
        })
      },
      getHotActor() {
        let hotActorApi = 'https://api.yopoo.cn/api/v1/hotactor'
        this.$http.get(hotActorApi, {
          params: {
            page: 1,
            count: 4
          }
        }).then(res => {
          this.hotActorList = res.data

        }, err => {
          console.log(err)
        })
      },
      getShowList() {
        let showListApi = 'https://api.yopoo.cn/api/v1/perfsearch'
        this.$http.get(showListApi, {
          params: {
            page: this.pageNum,
            count: 12
          }
        }).then((res) => {
          this.showList = res.data.data
        }, err => {
          console.log(err)
        })
      },
      pageChange(pInfo) {
        pInfo.pageSize = 10
        this.pageNum = pInfo.pageNumber
        //for example, do some http request, get new data and update totalRow property
        this.$http.get('https://api.yopoo.cn/api/v1/perfsearch?sex=' + this.sex + '&feature=' + this.feature + '&stature=' +
          this.stature + '&keyword=' + this.keyword + '&vocation=' + this.vocation + '&page=' + this.pageNum + '&count=' + pInfo.pageSize + '&sort=esc' +
          '&order=id').then((res) => {
          this.showList = res.data.data
          this.pageArr = res.data.pagination
          this.totalRow = res.data.pagination.total
        }, (err) => {
          console.log(err)
        })
        this.infoP = pInfo
      },
      Screening() {
        window.scrollTo(0, 0);
        this.screenShow = !this.screenShow
        this.maskShow = !this.maskShow
      },
      clickAll(event) {
        let sp = document.getElementById("myScreen");
        if (sp) {

          if (!sp.contains(event.target)) { //如果是sp以外的地方

            this.screenShow = false
            this.maskShow = false

          }

        }

      }
    },
    beforeMount() {
      this.getActorSwiper()
      this.getHotActor()
      this.getShowList()
      this.getSeo()
      // this.getDetails()
    },
    created() {
      this.navShow = false
    }
  }
</script>

<style scoped>
  .info-title {
    color: #666;
    padding-right: .22rem;
  }

  .a-info {
    width: 4.2rem;
    display: flex;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .info-c {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .actorList {
    font-size: .16rem;
    position: relative;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, .5);
  }

  .screen-wrapper {
    position: absolute;
    background: #fff;
    width: 100vh;
    height: 18rem;
    z-index: 1002;
  }

  .screen-content {
    width: 100%;
    font-size: .3rem;
  }

  .hotA-wrapper {
    display: flex;
    justify-content: center;
  }

  .hotActor-img-wrapper {
    margin: .4rem .08rem;
    width: 1.65rem;
    position: relative;
  }

  .hotActor {
    background: #fff;
  }

  /*172*258*/
  .hot-img-wrapper {
    width: 1.65rem;
    height: 2.58rem;
  }

  .hotA-img {
    width: 100%;
    height: 100%;
  }

  .hotTitle {
    padding-top: .3rem;
    margin-left: .10rem;
    font-size: .25rem; /*rem*/
    font-family: MicrosoftYaHei;
    font-weight: bold;
  }

  .hotIcon {
    width: .25rem;
    height: .25rem;
    margin-top: .07rem;
    color: #fff;
  }

  .searchActor {
    margin-top: .01rem;
    background: #fff;
    padding-top: .01rem;
  }

  .searchActorBtn {
    font-size: .3rem;
    background: #191919;
    margin: .20rem .12rem;
    height: .60rem;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .actList-wrapper {
    margin: .1rem .16rem;
  }

  .actImg {
    width: 1.65rem;
    height: 2.2rem;

  }

  .actorName {
    flex: 1;
    margin: 0 auto;
    padding-left: .5rem;
    width: auto;
    height: .51rem;
    font-size: .3rem;
    line-height: 1.8;
    color: #202020;
  }

  .shouActorList {
    display: flex;
    text-align: center;
  }

  .hot-num {
    display: flex;
    align-items: center;
    font-size: .16rem; /*rem*/
    font-family: MicrosoftYaHei;
    font-weight: 400;
    margin-top: .03rem;

  }

  .aName {
    font-size: .22rem; /*rem*/
    font-family: MicrosoftYaHei;
    font-weight: 400;
    display: flex;
    align-items: center;
    white-space: nowrap;
  }

  .hot-ab {
    display: flex;
    justify-content: space-around;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    position: absolute;
    width: 100%;
    top: 85%;
    bottom: 0;
    left: 0;
    right: 0;
    height: 15%;

  }

  .bk-search-btn {
    background: #191919;
    margin-top: 1rem;
    width: 1.8rem;
    height: .8rem;
    color: white;
    font-size: .3rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/ActorList.vue